import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export const LocationService = Symbol('LocationService');

export interface LocationService {
    readonly host: string;
    readonly pathname: string;
    readonly search: string;
}

@injectable()
export class LocationServiceImpl implements LocationService {
    
    get host() {
        /* istanbul ignore next */
        return window.location.host;
    }
    
    get pathname() {
        /* istanbul ignore next */
        return window.location.pathname;
    }
    
    get search() {
        /* istanbul ignore next */
        return window.location.search;
    }
}
